import { ApplicationConfig } from "@angular/core";
import { provideServices } from "./services";

export const sharedConfig: ApplicationConfig = {
  providers: [
    provideServices()
  ]
}